import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageSEO from '@/components/feature/PageSEO';
import HeroSection from './components/HeroSection';
import ServiceSection from './components/ServiceSection';
import StatsSection from './components/StatsSection';
import CaseSection from './components/CaseSection';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <PageSEO />
      <Navbar />
      <main>
        <HeroSection />
        <ServiceSection />
        <StatsSection />
        <CaseSection />
        <ArticleSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}